import { render, staticRenderFns } from "./mod-solicitud.vue?vue&type=template&id=7b68aac9&"
import script from "./mod-solicitud.vue?vue&type=script&lang=js&"
export * from "./mod-solicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports